import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "ticket-grid",
  name: "在售门票",
  icon: "票",
  group: "票务组件",
  description: "读取当前店铺已上架票种并展示售价和游玩日期。",
  defaultProps: {
    "title": "热门门票",
    "columns": 3,
    "limit": 12
}
}
